//== POPOVER MOBILE NAV
const toggleMobilePopover = document.getElementById('toggleMobilePopover')
const pnlMobilePopover = document.getElementById('pnlMobilePopover')
if (toggleMobilePopover && pnlMobilePopover) {
  pnlMobilePopover.addEventListener('toggle', () => {
    const isOpen = pnlMobilePopover.matches(':popover-open')
    toggleMobilePopover.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
    toggleMobilePopover.classList.toggle('is-active')
    document.body.classList.toggle('oflow-hidden')

    if (isOpen) {
      // watch the last focusable item
      const focusable = pnlMobilePopover.querySelectorAll(
        'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
      const lastItem = focusable[focusable.length - 1]
      lastItem.addEventListener('keydown', handleTabOut)
    }
  })

  function handleTabOut(e) {
    if (e.key === 'Tab' && !e.shiftKey) {
      e.preventDefault() //== prevent default tabbing away
      pnlMobilePopover.hidePopover() //== close the popover
      toggleMobilePopover.focus() //== return focus to the button
      e.target.removeEventListener('keydown', handleTabOut) //== clean up event
    }
  }
}
//== LEGACY MOBILE
//== mobile nav
const btnMobileNav = document.getElementById('toggleMobileNav')
const panelMobileNav = document.getElementById('pnlMobileNav')
const btnMobNavSide = document.getElementById('btnSideMenu')
const pnlMobNavSide = document.getElementById('pnlSideMenu')

let keyDownHandler
let activeModal

if (btnMobileNav && panelMobileNav) {
  btnMobileNav.addEventListener('click', function (e) {
    handleToggleMenu()
  })
}

const handleToggleMenu = () => {
  document.body.classList.toggle('oflow-hidden')
  panelMobileNav.classList.toggle('is-open')
  panelMobileNav.hidden = panelMobileNav.classList.contains('is-open') ? false : true
  btnMobileNav.classList.toggle('is-active')
  btnMobileNav.setAttribute('aria-expanded', panelMobileNav.classList.contains('is-open'))
  panelMobileNav.classList.contains('is-open') ? trapTabKey(panelMobileNav) : releaseTabKey()
}

//== mobile nav - side menu
if (btnMobNavSide && pnlMobNavSide) {
  btnMobNavSide.addEventListener('click', function (e) {
    btnMobNavSide.classList.toggle('is-active')
    btnMobNavSide.setAttribute('aria-expanded', btnMobNavSide.classList.contains('is-active'))
    pnlMobNavSide.classList.toggle('is-open')
  })
}

// KEY TRAPPER
function trapTabKey(modal) {
  activeModal = modal

  // focusable elements, but exclude hidden elements (display:none, visibility:hidden, or hidden via ancestor)
  let focusableElements = Array.from(
    modal.querySelectorAll('a, button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
  ).filter((el) => {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length)
  })

  document.addEventListener('keydown', handleEscape)

  const firstFocusable = focusableElements[0]
  const lastFocusable = focusableElements[focusableElements.length - 1]

  keyDownHandler = function (e) {
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === firstFocusable) {
          e.preventDefault()
          lastFocusable.focus()
        }
      } else {
        if (document.activeElement === lastFocusable) {
          e.preventDefault()
          handleToggleMenu() // close the modal
          // firstFocusable.focus()
        }
      }
    }
  }

  modal.addEventListener('keydown', keyDownHandler) // add the event listener using the keyDownHandler reference
  // firstFocusable.focus() // focus the first element when the modal opens
}

function releaseTabKey() {
  // Remove the event listeners using the stored reference
  if (activeModal && keyDownHandler) {
    activeModal.removeEventListener('keydown', keyDownHandler)
    document.removeEventListener('keydown', handleEscape)
    keyDownHandler = null // Clear the reference
  }
}

// allows menu to close when user hits Esc
function handleEscape(e) {
  if (e.key === 'Escape' || e.key === 'Esc') {
    e.preventDefault()
    handleToggleMenu() // close the menu
  }
}
